
import channelIO from "@/assets/js/channel-io";
import CommonUtils, { default as commonUtils } from "@/common-utils";
import Constants from "@/constants";
import { MstMemberVO } from "@/views/biz-global/join/vo/join.vo";
import { NoticeVO } from "@/views/biz/mypage/vo/mypage.vo";
import axios from "axios";
import { Swiper } from "swiper/js/swiper.esm";
import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import teleport from "vue2-teleport";
import TermsPop1 from "../../biz-kr/member/TermsPop1.vue";
import TermsPop2 from "../../biz-kr/member/TermsPop2.vue";
import BestFeeds from "../feed/BestFeeds.vue";
import Raffles from "../raffle/Raffles.vue";
import BestReviews from "../review/BestReviews.vue";
import Talks from "../talk/Talks.vue";
import { RelUgcBestVO } from "../ugc/vo/ugc.vo";
import Layout from "./Layout.vue";
import { LayoutDisplayItemOVO, LayoutOVO, MstMenuVO } from "./vo/main.vo";
import CommonModalDialog from "@/components/CommonModalDialog.vue";
import { isMobile } from "mobile-device-detect";


// 글로벌에서만 채팅 사용함
let channel;
if (CommonUtils.isSystemLocale("global") == true) {
  channel = new channelIO();
}

@Component({ components: { Layout, TermsPop1, TermsPop2, BestReviews, BestFeeds, Raffles, Talks, teleport, CommonModalDialog } })
export default class Main extends Vue {
  @Prop({ default: "" })
  layoutCd!: number;
  @PropSync("menuIdx", { default: 0 })
  currentMenuIdx!: number;

  menus = [] as Array<MstMenuVO>;
  layoutOVOs = [] as Array<LayoutOVO>;
  mainNotices: Array<NoticeVO> = [];
  // 서브 메뉴
  subMenuItems = [] as Array<LayoutDisplayItemOVO>;
  currentSubMenuIdx = 0;
  nextMenuLayoutCd = 100;

  pop = false; // 공지 팝업

  showTerms1 = false;
  showTerms2 = false;

  member = {} as MstMemberVO; // 로그인 회원

  // 메뉴바
  swiperMenu: Swiper;
  swiperMenuOption = {
    slidesPerView: "auto",
    spaceBetween: this.$isMobile ? 10 : 20,
    lazy: true,
  };

  // 메뉴
  swiperContents: Swiper;
  swiperContentsOption = {
    slidesPerView: 1,
    spaceBetween: 1,
    autoHeight: true,
    shortSwipes: false,
    longSwipesMs: 50,
    longSwipesRatio: 0.2,
    slideClass: "swiper-slide1",
    noSwipingClass: "no-swipe-with-parent",
    on: {
      slideChange: this.onMenuChanged,
    },
  };

  swiperMainPopup = {
    slidesPerView: 1,
    autoHeight: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };

  // 신규 토스트 알림 있음?
  get hasNewToastNotification() {
    if (!this.$store.state.newToastMessage.seq) {
      return false;
    }
    commonUtils.putLocalStorageObject(Constants.NOTIFICATION_SEQ1, Object(this.$store.state.newToastMessage.seq));
    return true;
  }

  // 현재 메뉴가 리뷰임?
  get isReview() {
    if (!this.layoutOVOs.length) {
      return false;
    }
    return this.layoutOVOs[this.currentMenuIdx].menuType == "034003";
  }

  // 현재 메뉴가 피드임?
  get isFeed() {
    if (!this.layoutOVOs.length) {
      return false;
    }
    return this.layoutOVOs[this.currentMenuIdx].menuType == "034004";
  }

  // 현재 메뉴가 톡톡임?
  get isTalk() {
    if (!this.layoutOVOs.length) {
      return false;
    }
    return this.layoutOVOs[this.currentMenuIdx].menuType == "034006";
  }

  // 하단 홈버튼
  @Watch("currentMenuIdx")
  onMenuIdxChangedForHome() {
    if (this.currentMenuIdx != 0) {
      return;
    }
    this.onMenuIdxChanged(0);
  }

  // 메뉴 인덱스 변경
  onMenuIdxChanged(idx: number) {
    this.currentMenuIdx = idx;
    this.getLayout(idx);
    this.swiperContents.slideTo(idx);
  }

  // 메뉴 이동
  onMenuChanged() {
    this.currentMenuIdx = this.swiperContents.activeIndex;
    this.swiperMenu.slideTo(this.swiperContents.activeIndex);
    this.loadNextSlide();
    window.scrollTo(0, -Constants.MENU_POSITION_TOP);
  }

  //토스트알림 읽음 처리
  readNotification() {
    axios.put(`/notification/${this.$store.state.newToastMessage.seq}`).then(() => {
      this.$router.push(this.$store.state.newToastMessage.link);
    });
  }

  // 오늘 그만 보기
  closeNotice(isHiddenToday: boolean) {
    if (isHiddenToday) {
      commonUtils.putLocalStorageObject(Constants.MAIN_NOTICE_HIDDEN_TODAY, new Date());
    }
    this.pop = !this.pop;
  }

  // 메뉴 컨텐츠 슬라이드 시
  loadNextSlide() {
    const prev = this.currentMenuIdx - 1;
    const next = this.currentMenuIdx + 1;
    const next2 = this.currentMenuIdx + 2;

    if (prev > 0) {
      this.getLayout(prev);
    }
    if (next < this.menus.length) {
      // 리뷰가 2번째 메뉴가 될 수 있어서..
      this.getLayout(next);
    }
    if (next2 < this.menus.length) {
      this.getLayout(next2);
    }
  }

  // 이빨 빠진 레이아웃 로드
  getLayout(idx: number): void {
    const nextMenu = this.menus[idx];
    const nextLayout = this.layoutOVOs[idx];
    // 리뷰, 피드, 톡톡
    if (["034003", "034004", "034006"].includes(nextLayout.menuType)) {
      let ugcTypeCd = "";
      switch (nextLayout.menuType) {
        case "034003": // 리뷰
          ugcTypeCd = "047001";
          break;
        case "034004": // 피드
          ugcTypeCd = "047002";
          break;
        case "034006": // 톡톡
          ugcTypeCd = "047011";
          break;
      }
      nextLayout.ugcs ||
        axios.get(`/ugc/best`, { params: { ugcTypeCd: ugcTypeCd } }).then((r) => {
          nextLayout.ugcs = r.data as Array<RelUgcBestVO>;
          this.$set(this.layoutOVOs, idx, nextLayout);
        });
      return;
    }
    // 래플
    if (nextLayout.menuType == "034005") {
      this.$set(this.layoutOVOs, idx, nextLayout);
      return;
    }
 
    if (nextMenu.layoutCd && !nextLayout.layout && nextMenu.layoutCd != this.nextMenuLayoutCd) {
      //모바일에서 스와이프때문에 api 중복호출되는것을 막기위해
      this.nextMenuLayoutCd = nextMenu.layoutCd
      // 일반 레이아웃
      axios.get(`/main/layouts/${nextMenu.layoutCd}`).then((r) => {
        const layoutOVO = r.data as LayoutOVO;
        layoutOVO.menuType = nextMenu.menuType;
        this.$set(this.layoutOVOs, idx, layoutOVO);
      });
    }
  }

  // layout component 내용 바뀌면 auto height 해줘야 함
  onLayoutUpdated(): void {
    this.swiperContents && this.swiperContents.updateAutoHeight();
  }

  activated() {
    // 알림 있음?
    this.$store.dispatch("updateNotification");

    // 채팅문의(글로벌), PC에서는 LyaoutMain(푸터)에 설정이 되어있음.
    if (channel && this.$isMobile == true) {
      axios.get("/login/simple-details").then((r) => {
        this.member = r.data;
        let language = process.env.VUE_APP_I18N_LOCALE || "en";

        // en, ko, ja 만 가능
        const allowLanguages = ["en", "ko", "ja"];

        if (allowLanguages.includes(language) == false) {
          language = "en";
        }

        const settings = {
          pluginKey: process.env.VUE_APP_CHANNEL_IO_PLUGIN_KEY,
          customLauncherSelector: ".customer_center",
          hideChannelButtonOnBoot: true,
          language: language,
          hidePopup: true,
        };

        // 로그인했다면
        if (this.member) {
          Object.assign(settings, {
            memberId: this.member.memCd,
            profile: {
              name: this.member.memNm,
              mobileNumber: this.member.memPh,
              email: this.member.memEmail,
              avatarUrl: this.member.memProfileFileUrl,
            },
          });
        }

        channel.boot(settings);
      });
    }
  }

  goLink(result: any): void {
    this.$router.push(result.url);
  }
  callbackUrl(result: any): void {
    if (result.url) {
      this.$router.push(result.url);
    }
  }
  created() {
    // 알림 있음?
    this.$store.dispatch("updateNotification");
    // 메뉴
    axios.get(`/menus/${this.layoutCd}`, { params: { debug: this.$route.query.debug, isMobile: this.$isMobile } }).then((r) => {
      this.menus = r.data.menus;
      this.layoutOVOs = r.data.layoutOVOs;
      this.mainNotices = r.data.notices;
      // 메뉴 직접 요청
      if (this.$route.params.initMenuIdx) {
        const menuIdx = Number(this.$route.params.initMenuIdx);
        this.$nextTick().then(() => {
          menuIdx > 0 && this.onMenuIdxChanged(menuIdx);
        });
      }
      if (window["ReactNativeWebView"]) {
        this.$nextTick().then(() => {
          window["webViewBridge"].send("moveUrl", {}, this.callbackUrl);
        });
      }

      // 공지 ////////////////////////////////////////////////////////////////////////////////////////////////////
      // 오늘 하루 보지 않기 함?
      const mainNoticeHiddenDate = commonUtils.getLocalStorageObject(Constants.MAIN_NOTICE_HIDDEN_TODAY);
      if (mainNoticeHiddenDate) {
        const todayDate = new Date();
        const hiddenDate = new Date(mainNoticeHiddenDate);

        const today = todayDate.getFullYear() + todayDate.getMonth() + todayDate.getDate();
        const hidden = hiddenDate.getFullYear() + hiddenDate.getMonth() + hiddenDate.getDate();

        // 오늘 하루 보지 않기 한게 오늘임?
        if (today == hidden) {
          return;
        }
      }
      this.mainNotices.length && (this.pop = true);
      // 공지 ////////////////////////////////////////////////////////////////////////////////////////////////////
    });

  }
}
